(function() {
  'use strict';

  angular
      .module('showcaseApp')
      .filter('cpfCnpj', cpfCnpj);

  cpfCnpj.$inject = ['cpfCnpjFilterConstants'];

  function cpfCnpj(cpfCnpjFilterConstants) {
      return cpfCnpj;

      function cpfCnpj(value, force) {
          if (value === null || value === undefined) {
              return value;
          }

          // normaliza: maiúsculas e sem formatação, suportando CNPJ alfanumérico (IN RFB 2229/2024)
          // e preservando '*' para valores já ofuscados pelo backend
          var v = value.toString().toUpperCase().replace(/[^0-9A-Z*]/g, '');

          if (force === cpfCnpjFilterConstants.TYPE.CPF) {
              return formatCpf(v);
          }
          if (force === cpfCnpjFilterConstants.TYPE.CNPJ) {
              return formatCnpj(v);
          }
          return v.length <= 11 ? formatCpf(v) : formatCnpj(v);
      }

      function formatCpf(v) {
          var cpf = v.slice(0, 3);
          if (v.length > 3) cpf += '.' + v.slice(3, 6);
          if (v.length > 6) cpf += '.' + v.slice(6, 9);
          if (v.length > 9) cpf += '-' + v.slice(9, 11);
          return cpf;
      }

      function formatCnpj(v) {
          var cnpj = v.slice(0, 2);
          cnpj += '.' + v.slice(2, 5);
          cnpj += '.' + v.slice(5, 8);
          cnpj += '/' + v.slice(8, 12);
          if (v.length > 12) cnpj += '-' + v.slice(12, 14);
          return cnpj;
      }
  }
})();
